module.exports = __webpack_public_path__ + "static/media/trailways-logo.42222e85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trailways/trailways-logo.svg
// module id = 167
// module chunks = 0